
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component({
  components: {},
  mixins: []
})
export default class PreviewConfigurationTextPanel extends Vue {
  @Prop(Object) item!: any

  mounted() {
    console.log('mounted', this.item)
  }

  onCloseHandler() {
    this.$emit('closePanel', {})
  }
}
